<template>
    <div class="tab">
      <div class="row_iconbox">
        <img :src="li.ImgUrl" alt="" class="row_icon">
      </div>
        <div class="row_title">{{li.Title}}</div>
    </div>
</template>
<script>
export default {
    data() {
        return{
          li:null,
        }
    },
    props:['tab'],
    watch:{
      tab:{
        handler(newName, oldName) {
          this.li=newName
        },
      deep: true,
      immediate: true
      }
    }
}
</script>
<style lang="scss" scoped>
.row_iconbox{
        width: 3.375rem;
        height: 3.375rem;
        background: #fff;
        padding: 0.68rem;
        box-sizing: border-box;
        border-radius: 50%;
        margin: 0 auto 0.75rem;
}
    .row_icon{
       width: 2rem;
    }
    .row_title{
      font-size: 0.75rem;
      letter-spacing: 0;
      text-align: center;
      line-height: 0.75rem; 
    }
</style>



// WEBPACK FOOTER //
// src/components/tab.vue